import { httpClient } from '@/core/services/http'
import { createGetCategoriesUseCase } from '../usecases/get-categories.usecases'
import { createGetChildCategoriesUseCase } from '../usecases/get-child-categories.usecase'

export const getCategories = createGetCategoriesUseCase({
  httpClient,
})
export const getChildCategories = createGetChildCategoriesUseCase({
  httpClient,
})
